import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { cn } from '@/lib/utils';

export const chatMarkdownStyles = cn(
  'text-sm flex flex-col gap-2',
  '[&_p]:mb-1 [&_p]:last:mb-0',
  '[&_a]:text-stone-900 [&_a]:underline [&_a]:font-medium [&_a:hover]:text-stone-600',
  '[&_code]:bg-stone-200 [&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded [&_code]:text-xs [&_code]:font-mono',
  '[&_pre]:bg-stone-200 [&_pre]:p-2 [&_pre]:rounded [&_pre]:overflow-x-auto [&_pre]:my-1',
  '[&_ul]:pl-4 [&_ul]:my-1 [&_ul]:list-disc',
  '[&_ol]:pl-4 [&_ol]:my-1 [&_ol]:list-decimal',
  '[&_li]:mb-0.5',
  '[&_strong]:font-semibold',
  '[&_em]:italic',
  '[&_h2]:text-base [&_h2]:font-semibold [&_h2]:mt-2 [&_h2]:mb-1',
  '[&_h3]:text-sm [&_h3]:font-semibold [&_h3]:mt-1 [&_h3]:mb-0.5',
  '[&_blockquote]:border-l-2 [&_blockquote]:border-stone-400 [&_blockquote]:pl-3 [&_blockquote]:italic [&_blockquote]:text-stone-600 [&_blockquote]:my-1',
  '[&_table]:text-xs [&_table]:border-collapse',
  '[&_thead]:bg-stone-200',
  '[&_th]:px-2 [&_th]:py-1.5 [&_th]:text-left [&_th]:font-semibold [&_th]:text-stone-700 [&_th]:border-b [&_th]:border-stone-300',
  '[&_td]:px-2 [&_td]:py-1.5 [&_td]:border-b [&_td]:border-stone-200',
  '[&_tr:last-child_td]:border-b-0',
  '[&_tr:hover]:bg-stone-50',
  '[&_td]:tabular-nums',
);

const chatMarkdownComponents = {
  table: ({
    node,
    children,
    ...props
  }: React.ComponentPropsWithoutRef<'table'> & { node?: unknown }) => (
    <div className="overflow-x-auto rounded-md border border-stone-300 max-w-full">
      <table {...props}>{children}</table>
    </div>
  ),
};

interface ChatMarkdownProps {
  children: string;
  className?: string;
}

export function ChatMarkdown({ children, className }: ChatMarkdownProps) {
  return (
    <div className={cn(chatMarkdownStyles, className)}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={chatMarkdownComponents}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
